import { render } from "./PagePdfColorSettings.vue?vue&type=template&id=040f0579&scoped=true"
import script from "./PagePdfColorSettings.vue?vue&type=script&lang=js"
export * from "./PagePdfColorSettings.vue?vue&type=script&lang=js"

import "./PagePdfColorSettings.vue?vue&type=style&index=0&id=040f0579&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-040f0579"

export default script